import React, { useState } from 'react';
import { authChangePassword } from '../../utils/api';

export default function ChangePasswordModal({ onClose }) {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      setError('Заповніть усі поля');
      return;
    }
    if (form.newPassword.length < 6) {
      setError('Новий пароль мінімум 6 символів');
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError('Паролі не співпадають');
      return;
    }
    setLoading(true);
    try {
      await authChangePassword({
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });
      setSuccess('Пароль успішно змінено!');
      setTimeout(onClose, 1800);
    } catch (err) {
      setError(err.response?.data?.message || 'Помилка зміни пароля');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="admin-modal">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 style={{ margin: 0 }}>Зміна пароля</h2>
          <button className="admin-btn secondary" onClick={onClose} style={{ padding: '6px 12px' }}>✕</button>
        </div>

        {success ? (
          <div style={{ textAlign: 'center', padding: '24px 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: 12 }}>✅</div>
            <p style={{ color: 'var(--green-deep)', fontWeight: 600 }}>{success}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="admin-form-group">
              <label>Поточний пароль</label>
              <input
                name="currentPassword"
                type="password"
                placeholder="••••••••"
                value={form.currentPassword}
                onChange={handleChange}
                autoFocus
              />
            </div>
            <div className="admin-form-group">
              <label>Новий пароль</label>
              <input
                name="newPassword"
                type="password"
                placeholder="мінімум 6 символів"
                value={form.newPassword}
                onChange={handleChange}
              />
            </div>
            <div className="admin-form-group">
              <label>Підтвердити новий пароль</label>
              <input
                name="confirmPassword"
                type="password"
                placeholder="повторіть новий пароль"
                value={form.confirmPassword}
                onChange={handleChange}
              />
            </div>
            {error && (
              <p style={{ color: '#dc2626', fontSize: '0.85rem', marginBottom: 8 }}>{error}</p>
            )}
            <div className="admin-form-actions">
              <button type="button" className="admin-btn secondary" onClick={onClose}>Скасувати</button>
              <button type="submit" className="admin-btn primary" disabled={loading}>
                {loading ? 'Збереження...' : 'Змінити пароль'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
